class Groupon.MerchantVideos

  constructor: (@el, @provider, @videoId, @onlyShowingVideos) ->
    @$videos = $ @el
    @OOVideo = null
    @getVideoScripts()
    @MIN_WIDTH = 979

    $(window).on 'resize', => @onResize()

  getVideoScripts: ->
    $ =>
      switch @provider
        when 'KALTURA'
          script = '//www.kaltura.com/p/1302621/sp/130262100/embedIframeJs/uiconf_id/11486911/partner_id/1302621'
        when 'OOYALA'
          script = '//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388'
        else
          return @removeVideoContainer()

      $.getScript(script)
        .done(=> @setupVideo())
        .fail(=> @removeVideoContainer())

  setupVideo: ->
    if kWidget?
      kWidget.embed({
        targetId: 'kaltura-player-1360194818',
        cache_st: 1360194818,
        wid: '_1302621',
        uiconf_id: '11486911',
        flashvars: {
          autoPlay: false,
          streamerType: 'hdnetwork',
          akamaiHD: {
            loadingPolicy: 'preInitialize',
            asyncInit: 'true'
          }
        },
        entry_id: @videoId
      })
    else if OO?
      @OOVideo = OO.Player.create 'ooyala-player', @videoId,
        autoplay: false

  removeVideoContainer: ->
    if @onlyShowingVideos
      @$videos.parent().remove()
    else
      @$videos.remove()

  destroyOoyalaVideo: ->
    if OO? and $(window).width() <= @MIN_WIDTH
      @OOVideo?.destroy()
      @OOVideo = null

  createOoyalaVideo: ->
    if OO? and $(window).width() > @MIN_WIDTH and not @OOVideo
      @OOVideo = OO.Player.create 'ooyala-player', @videoId,
        autoplay: false

  onResize: ->
    clearTimeout(timer) if timer
    timer = setTimeout (=>
      @destroyOoyalaVideo()
      @createOoyalaVideo()
    ), 250

$ ->
  el = '.mpp-container .merchant-videos'
  return unless $(el).length > 0

  videosConfig = $(el).data()

  new Groupon.MerchantVideos(el, videosConfig.provider, videosConfig.videoId, videosConfig.onlyVideos)
